import { Fragment } from "react";
import App from "./App";

export const InternetProtected = () => {
  return (
    <Fragment>
      <App />
    </Fragment>
  );
};
